<template>
    <v-dialog
        v-model="value"
        max-width="600"
    >
        <v-card class="py-3 px-5">
            <v-form ref="form" v-model="valid">
                <v-row>
                    <v-col>
                        <v-text-field
                            :rules="[value => !!value || 'Required.']"
                            label="Label"
                            required
                            v-model="item.label"
                        />
                    </v-col>
                </v-row>
            </v-form>
            <v-card-actions>
                <v-btn 
                    class="mr-3" 
                    outlined 
                    color="primary darken-1"
                    @click="handleCancel"
                >
                    Cancel
                </v-btn>
                <v-btn 
                    class="white--text" 
                    color="primary darken-1"
                    @click="handleSave"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'ProjectMeetingDetails',

        props: {
            item: {
                type: Object,
                required: true,
                default: {}
            },
            value: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            valid: false
        }),
    
        methods: {
            handleCancel: function () {
                this.$emit('input', false);
            },
            handleSave: async function () {
                this.valid = this.$refs.form.validate();

                if (this.valid) {
                    this.$emit('save', this.item);
                    this.$emit('input', false);
                }
            }
        }
    }
    
</script>


// WEBPACK FOOTER //
// src/components/datamanagement/ProjectMeetingDetails.vue